import { createFileRoute } from '@tanstack/react-router';
import { Companies } from '../pages/Companies';

export const Route = createFileRoute('/_auth/companies/')({
  component: Companies,
});